import SettingsExpertTeamMemberEditModalComponent from './team-member-edit-modal.component'

const SettingsExpertTeamMemberEditModalModule = angular.module('cdbl.team-member-edit-modal', [

])
  .component('cdblSettingsExpertTeamMemberEditModal', SettingsExpertTeamMemberEditModalComponent)
  .name

export default SettingsExpertTeamMemberEditModalModule
